import { Component, OnInit } from '@angular/core';
import { map, tap, switchMap, mergeMap, filter, concatMap } from 'rxjs/operators';
import { AuthService } from 'src/app/Services/auth.service';
import { CommonAppService } from 'src/app/Services/common-app.service';
import { DataService } from 'src/app/Services/data.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.css']
})
export class CompanyInfoComponent implements OnInit {

  editing : boolean = false;
  groupInfo : any = {};
  smCI : any = {};
  iccInfo : any = {};
  subUsers : any = [];
  adminInfo : any;

  appConst : any = {
    role : {
      admin : 200,
      user: 300
    },
    groupType: {
      system: 1000,
      MC: 1001,
      ICC: 1002,
      TSP: 1003
    }

  };

  //create seperate file later
  states : any = [{ "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "American Samoa", "abbreviation": "AS" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, { "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, { "name": "District Of Columbia", "abbreviation": "DC" }, { "name": "Federated States Of Micronesia", "abbreviation": "FM" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Guam", "abbreviation": "GU" }, { "name": "Hawaii", "abbreviation": "HI" }, { "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, { "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Marshall Islands", "abbreviation": "MH" }, { "name": "Maryland", "abbreviation": "MD" }, { "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, { "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, { "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, { "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Northern Mariana Islands", "abbreviation": "MP" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, { "name": "Oregon", "abbreviation": "OR" }, { "name": "Palau", "abbreviation": "PW" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Puerto Rico", "abbreviation": "PR" }, { "name": "Rhode Island", "abbreviation": "RI" }, { "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, { "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virgin Islands", "abbreviation": "VI" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, { "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" }]


  constructor(private authService : AuthService, private dataService : DataService, private commAppService : CommonAppService) { }

  getsmCI() {
    this.smCI.EditCompanyInfoBtn = false;
    let authData = JSON.parse(localStorage.getItem('authorizationData'));
    this.authService._getsmData(authData.userRole, authData.groupType, "CompanyInfoHtml")
      .subscribe((result) => {
        this.smCI.EditCompanyInfoBtn = this.authService._accessFilter(result, "EditCompanyInfoBtn");                        
      })
  };

  loadData() {
    this.dataService._getGroupInfo()
      .pipe(
        concatMap(result => {
          this.groupInfo = result;
          return this.dataService._getGroupInfo(result.IccID, this.appConst.groupType.ICC);
        }),
        concatMap(IccResult => {
          this.iccInfo = IccResult;
          return this.dataService._getSubUsers();
        }))
        .subscribe(subUserInfo => {
          this.subUsers = _.filter(subUserInfo, (item) => { return item.Role === this.appConst.role.admin; });

          this.adminInfo = _.filter(this.subUsers, { UserId: this.groupInfo.AdminId });
          this.adminInfo = this.adminInfo[0];
        })
  };

  edit() {
    this.editing = true;
  }
  cancelUpdate() {
    this.editing = false;
  }

  updateCompanyInfo() {
    this.dataService._updateMutualCustomer(this.groupInfo).subscribe((result) => {
      this.commAppService._snackBar(true, 'Contact Updated');
      this.editing = false;
      //$rootScope.mcInfoChanged = false;
      // NotifyingService.notify();
      this.loadData();
    });
  }

  ngOnInit(): void {

    this.getsmCI();
    this.loadData();
  }
}
